document.addEventListener('DOMContentLoaded', function () {
  var tabs = document.querySelectorAll('.kal-doc-nav__tab');

  var sections = [];
  tabs.forEach(function (tab) {
    var id = tab.getAttribute('href').replace('#', '');
    var el = document.getElementById(id);
    if (el) sections.push({ id: id, el: el });
  });

  function setActive(anchorId) {
    tabs.forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('href') === '#' + anchorId);
    });
  }

  // Helper: get dynamic height of header + announcement + nav bar
  function getOffset() {
    var rootStyles = getComputedStyle(document.documentElement);
    var hHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
    var aHeight = parseFloat(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
    
    var nHeight = 0;
    // Nav is only sticky on mobile, so only offset its height on mobile
    if (window.innerWidth <= 768) {
      var navEl = document.querySelector('.kal-doc-nav');
      if (navEl) nHeight = navEl.offsetHeight;
    }
    
    return hHeight + aHeight + nHeight;
  }

  var isClickScrolling = false;
  var scrollTimeout;

  // Click: set active immediately and scroll smoothly
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href').replace('#', '');
      var targetEl = document.getElementById(targetId);
      
      if (targetEl) {
        e.preventDefault(); // Prevent default anchor jump
        
        // 1. Temporarily disable scroll-spy
        isClickScrolling = true;
        
        // 2. Set active tab immediately for fast feedback
        setActive(targetId);
        
        // 3. Smooth scroll to section (accounting for dynamic header offset)
        var offset = getOffset() + 20; // 20px extra breathing room
        var targetPosition = targetEl.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });

        // 4. Re-enable scroll spy after scroll completes
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          isClickScrolling = false;
        }, 800); // 800ms is generally enough for smooth scroll to finish
      }
    });
  });

  // Get true document-level top position of an element.
  function getDocumentTop(el) {
    return el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
  }

  // Scroll-spy: the last section whose document top is above scrollPos wins
  function onScroll() {
    if (!sections.length || isClickScrolling) return; // Skip if clicked
    
    var scrollPos = (window.scrollY || window.pageYOffset) + getOffset() + 50;
    var activeId = sections[0].id;

    for (var i = 0; i < sections.length; i++) {
      if (getDocumentTop(sections[i].el) <= scrollPos) {
        activeId = sections[i].id;
      }
    }

    setActive(activeId);
  }

  var scrollTimer;
  window.addEventListener('scroll', function () {
    if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
    scrollTimer = window.requestAnimationFrame(onScroll);
  }, { passive: true });

  onScroll(); // initialize on load
});
